<template>
  <div>
      <v-dialog
        v-model="loading"
        persistent
        width="600"
        >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Proccessing<span v-if="customLogLead"> | Lead: {{customLogLead}}</span><span v-if="customLog"> | {{ customLog }}</span>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs12 px-2 pb-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Settings
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="settingscard = !settingscard">toggle
              </v-btn>
						</v-card-title>
            <v-card-actions v-if="settingscard">
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text v-if="settingscard">
              <v-layout row wrap>
                <v-flex xs4>
                  <v-select
                    :items="warehouses"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    v-model="whsource"
                    label="Source"
                    return-object
                    item-text="text"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs4 px-1>
                  <v-btn color="success" block @click="importAlternatives()">import alternatives to</v-btn>
                  <span style="font-weight:bold;" v-if="whsource">{{whsource.name}}</span> alternatives will be imported to <span style="font-weight:bold;" v-if="whtarget">{{whtarget.name}}</span>
                </v-flex>
                <v-flex xs4>
                  <v-select
                    :items="warehouses"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    v-model="whtarget"
                    label="Target"
                    return-object
                    item-text="text"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 pa-3 v-if="importingAlt" style="font-size:22px;font-weight:bold;">
                  {{importingAlt}}
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider v-if="settingscard"></v-divider>
            <v-card-text v-if="settingscard">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="settings"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    return-object
                    v-model="selectedSetting"
                    label="Settings For"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-if="settingscard">
              <v-layout row wrap>
                <v-flex xs12 v-if="selectedSetting">
                  <v-layout row wrap>
                    <v-flex xs12 px-1>
                      <v-card class="pa-2">
                        <v-layout row wrap>
                          <v-flex xs3 px-1>
                            <v-select
                              :items="loadedDbCountries"
                              v-model="selectedSetting.country"
                              multiple
                              clearable
                              chips
                              solo
                              label="Countries"
                            ></v-select>
                          </v-flex>
                          <v-flex xs4 px-1>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-layout row wrap v-for="(wh, k) in selectedSetting.warehouses" :key="'warehouse'+k" pb-1>
                                  <v-flex xs6>
                                    <v-select
                                      :items="warehouses"
                                      solo
                                      :disabled="loading || syncing"
                                      :loading="loading"
                                      v-model="wh.name"
                                      label="Warehouse"
                                      item-text="name"
                                      hide-details
                                    ></v-select>
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    <v-text-field
                                      label="Priority"
                                      v-model="wh.priority"
                                      solo
                                      hide-details
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs3 px-1>
                                    <v-text-field
                                      label="Limit"
                                      v-model="wh.limit"
                                      solo
                                      hide-details
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12>
                                <v-btn outline color="primary" dark @click="addWareHouseToSettings()">add warehouse</v-btn>
                              </v-flex>
                            </v-layout>
                            
                          </v-flex>
                          <v-flex xs3 px-1>
                            <v-autocomplete
                              label="Products"
                              :items="products"
                              v-model="selectedSetting.upsell"
                              item-text="sku"
                              item-value="sku"
                              :disabled="loading || syncing"
                              :loading="loading"
                              multiple
                              chips
                              solo
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs2 px-1>
                            <v-autocomplete
                              label="Delivery SKU"
                              :items="products"
                              v-model="selectedSetting.delivery"
                              item-text="sku"
                              item-value="sku"
                              :disabled="loading || syncing"
                              :loading="loading"
                              multiple
                              chips
                              solo
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs4 px-1>
                            <v-checkbox label="Address & Name Must Be English" v-model="selectedSetting.english" value="true"></v-checkbox>
                          </v-flex>
                          <v-flex xs4 px-1>
                            <v-checkbox label="Generate Document ID" v-model="selectedSetting.genDocID" value="true"></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="settingscard">
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!selectedSetting" @click="updateSettings()">Update Settings</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 WAREHOUSE>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Warehouse
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="warehousecard = !warehousecard">toggle
              </v-btn>
						</v-card-title>
            <v-card-actions v-if="warehousecard">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="290">
                <v-btn color="primary" dark slot="activator">add a warehouse</v-btn>
                <v-card>
                  <v-card-title class="headline">New Warehouse</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          :items="countries"
                          solo
                          v-model="nwarehouse.country"
                          label="Country"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Name"
                          solo
                          v-model="nwarehouse.name"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="dialog=false">close</v-btn>
                    <v-btn @click="warehouseAdd()" :loading="loading" color="success" dark>
                      add warehouse
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogImport" persistent max-width="700">
                <v-btn color="primary" class="ml-2" dark slot="activator">Import to Warehouses</v-btn>
                <v-card>
                  <v-card-title class="headline">Import Products</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12 pa-1>
                        <v-textarea
                          label="Keys OR Document Numbers"
                          v-model="pastedData"
                          solo
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 class="title text-xs-center">
                        {{importDone}} / {{importTotal}}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click.native="dialogImport = false">Cancel</v-btn>
                    <v-btn color="primary" @click.native="importWarehouses()">Import</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
            <v-card-text v-if="warehousecard">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select
                    :items="warehouses"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    return-object
                    v-model="selectedWarehouse"
                    label="Warehouse"
                    @change="loadWarehouseProducts"
                    item-text="name"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="warehousecard">
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!selectedWarehouse" @click="exportWarehouseh()">Export warehouse</v-btn>
            </v-card-actions>
            <v-card-text v-if="warehousecard">
              <v-layout row wrap>
                <v-flex xs12 v-if="selectedWarehouse">
                  <v-layout row wrap style="height:600px;overflow-y:scroll;">
                    <v-flex xs12 px-1>
                      <v-layout row wrap>
                        <v-flex xs3 style="font-weight:bold;">
                          Name
                        </v-flex>
                        <v-flex xs3 style="font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs3 style="font-weight:bold;">
                          Quantity
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(product, i) in selectedWarehouse.products" :key="'warehouseProducts'+i" px-1>
                      <v-card class="pa-2">
                        <v-layout row wrap>
                          <v-flex xs3>
                            {{product.item_name}} 
                          </v-flex>
                          <v-flex xs3>
                            {{product.sku}}
                          </v-flex>
                          <v-flex xs3>
                            {{product.warehouses.filter(x=>x.warehouse==selectedWarehouse.name)[0].quantity}}
                          </v-flex>
                          <v-flex xs3>
                            <v-btn color="success" flat small @click="selectedProduct = products.filter(x=>x.key == product.key)[0]">edit</v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2 PRODUCTS>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Products
              <v-spacer></v-spacer>
              {{backupsku}}
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="productscard = !productscard">toggle
              </v-btn>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="backuplive()">backup
              </v-btn>
						</v-card-title>
            <v-card-text v-if="productscard">
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-autocomplete
                    label="Products"
                    :items="products"
                    v-model="selectedProduct"
                    item-text="item_name"
                    return-object
                    :disabled="loading || syncing"
                    :loading="loading"
                    solo
                  ></v-autocomplete>
              	</v-flex>                
              </v-layout>
              <v-layout row wrap v-if="selectedProduct">
                <v-flex xs12 class="text-xs-center title">
                  {{selectedProduct.sku}}
                </v-flex>
								<v-flex v-for="(warehouse, k) in selectedProduct.warehouses" :key="k + 'warehouse'" xs12 py-1 >
									<v-card>
										<v-layout row wrap align-center pa-4 class="grey lighten-4">
											<v-flex xs6 px-1>
												Warehouse
												<v-autocomplete
													:items="warehouses"
													v-model="selectedProduct.warehouses[k].warehouse"
													label="Select a warehouse"
													solo
													clearable
                          item-value="name"
                          item-text="name"
													hide-details
													:loading="loading"
													:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
													@click:append-outer="dialog = true"
												></v-autocomplete>
											</v-flex>
											<v-flex xs4 px-1>
												Quantity
												<v-text-field
													v-model="selectedProduct.warehouses[k].quantity"
													hide-details
													@keypress="isNumber($event)"
													solo
												></v-text-field>
											</v-flex>
                      <v-flex v-if="superAdmin" xs1 class="text-xs-center">
												<v-btn @click="removeWearhouse(k)" color="error" icon flat dark px-2>
													<v-icon size="16px">close</v-icon>
												</v-btn>
											</v-flex>
											<v-flex xs12 px-1 pt-2 style="font-weight:bold;">
                        Alternatives
											</v-flex>
                      <v-flex v-for="(alternative, d) in warehouse.alternatives" :key="d + 'alternative'" xs12 py-1>
                        <v-card>
                          <v-layout row wrap align-center pa-2>
                            <v-flex xs6 px-1>
                              Alternative
                              <v-autocomplete
                                label="Products"
                                :items="products"
                                v-model="alternative.sku"
                                item-text="sku"
                                :disabled="loading || syncing"
                                :loading="loading"
                                solo
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                              {{alternative.priority}}
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 class="text-xs-center">
                        <v-btn @click="addAlternative(k)" color="primary" flat px-2 >
                          <v-icon left size="16px">add</v-icon>
                          add an alternative
                        </v-btn>
                      </v-flex>
											
										</v-layout>
									</v-card>
								</v-flex>
                <v-flex xs12 class="text-xs-center">
									<v-btn @click="addWarehouse(selectedProduct.key)" color="primary" dark px-2>
										<v-icon left size="16px">add</v-icon>
										add a warehouseh
									</v-btn>
									<v-btn @click="saveWareHousesToProduct()" color="success" 
										v-if="selectedProduct.warehouse && selectedProduct.warehouse.length > 0" 
										dark 
										px-2>
										<v-icon left size="16px">save</v-icon>
										save warehousing
									</v-btn>
								</v-flex>
							</v-layout>
            </v-card-text>
            <v-card-actions v-if="productscard">
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-btn color="primary" @click="updateProduct()">update product</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 px-2 pt-2 RESERVATION>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Order Reservation
              <v-spacer></v-spacer>
              <v-text-field
                label="limit"
                v-model="limit"
                dark
                solo
                hide-details
              ></v-text-field>
              <v-btn color="info" :disabled="!leads.length" @click="exportData()" :disable="!leads.length">Export</v-btn>
              <v-btn color="info" @click="reserve()">Proccess Orders</v-btn>
              <v-btn color="error" @click="cancelAllReservation()">Cancel</v-btn>
              <v-btn color="success" @click="confirmReservation(true)" :disable="!leads.length">Confirm (B)</v-btn>
              <v-btn color="success" @click="confirmReservation(false)" :disable="!leads.length">Confirm (F)</v-btn>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="reservationcard = !reservationcard">toggle
              </v-btn>
              <v-switch label="Test" v-model="testing" color="white" dark></v-switch>
						</v-card-title>
            <v-card-text v-if="reservationcard">
              <v-layout row wrap>
                <v-flex xs12 pb-2>
                  <v-card class="elevation-4">
                    <v-layout row wrap>
                      <v-flex xs6 v-for="(warehouse, i) in nwarehouses" :key="i + '-warehouse'" py-2 ma-0 class="elevation-2">
                        <div class="caption grey--text " v-if="!warehouse.name">No Warehouse</div>
                        <div class="caption" v-if="!warehouse.name">{{warehouse.name}}</div>
                        <div class="caption" v-if="!warehouse.name">{{warehouse.count}}</div>
                        <div class="caption grey--text " v-if="warehouse && warehouse.name">Warehouse</div>
                        <div class="caption" v-if="warehouse && warehouse.name">{{warehouse.name}}</div>
                        <div class="caption" v-if="warehouse && warehouse.name">{{warehouse.count}}</div>
                        <v-btn color="success" flat small @click="exportData(warehouse.export, warehouse.name, true)">export {{warehouse.export.length}}</v-btn>
                        <v-layout row wrap>
                          <v-flex xs2 v-for="(product, k) in warehouse.products" :key="k + '-product'">
                            <div class="caption">{{product.sku}}</div>
                            <div class="caption">{{product.count}}</div>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="false">
								<v-flex xs12 md12 pb-1 v-for="(lead, i) in leads" :key="i + '-lead'">
                  <v-card>
                    <v-layout row wrap py-1>
                      <v-flex xs12 md1>
                        <div class="caption grey--text ">Key</div>
                        <v-tooltip top>
                          <span slot="activator"
                            v-clipboard:copy="lead.key"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                            style="font-size:9px;"
                          >
                            {{lead.key}}
                          </span>
                          <span>{{ lead.key }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs12 md1>
                        <div class="caption grey--text ">Country</div>
                        <v-tooltip top>
                          <span slot="activator"
                            v-clipboard:copy="lead.key"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >
                            {{ lead.country }}
                          </span>
                          <span>{{ lead.country }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs12 md2 >
                        <div class="caption grey--text ">Warehouse</div>
                        <v-select
                          :items="warehouses"
                          solo
                          @change="changeReserve(lead, $event)"
                          :disabled="loading || syncing"
                          :loading="loading"
                          return-object
                          v-model="lead.reserve.warehouse"
                          label="Warehouse"
                          item-text="name"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 md2 v-if="lead.reserve">
                        <div class="caption grey--text ">Original Order</div>
                        <div class="caption" v-for="(item, k) in lead.order" :key="k + '-item'">
                          {{item.sku}} X {{item.quantity}}
                        </div>
                      </v-flex>
                      <v-flex xs12 md2 v-if="lead.reserve">
                        <div class="caption grey--text ">Reserved Order</div>
                        <div class="caption" v-for="(item, k) in lead.reserve.products" :key="k + '-aitem'">
                          <span :style="`${item.alternative? 'background:#efefef;padding:1px;' : null}`">
                            {{item.sku}} X {{item.quantity}}
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 md1>
                        <div class="caption grey--text ">Note</div>
                        <div class="caption ">{{lead.note}}</div>
                        <div class="caption ">{{lead.cancel_note}}</div>
                      </v-flex>
                      <v-flex xs12 md1>
                        <v-chip :color="`${lead.reserve.warehouse? 'success':'error'}`" small label text-color="white">
                          <v-avatar>
                            <v-icon v-if="lead.reserve.warehouse">done</v-icon>
                            <v-icon v-if="!lead.reserve.warehouse">close</v-icon>
                          </v-avatar>
                          R
                        </v-chip>
                      </v-flex>
                      <v-flex xs12 md1>
                        <v-chip v-if="lead.upsell" :color="`${lead.upsell? 'error':'error'}`" small label text-color="white">
                          <v-avatar>
                            <v-icon v-if="lead.upsell">close</v-icon>
                          </v-avatar>
                          U
                        </v-chip>
                      </v-flex>
                      <v-flex xs12 md1>
                        <v-btn outline color="error" small v-if="lead.reserve.warehouse" @click="cancelLeadReservation(lead, i)">cancel</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
              	</v-flex>                
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="reservationcard">
              <v-spacer></v-spacer>
              <v-btn color="info" @click="reserve()">Proccess Orders</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate, sleep} from '@/customFunction';
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
import json2csv from 'json2csv'
import countriesJSON from '@/countries-ash.json'
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
let apiBaseStaging = 'https://us-central1-ashyaatcrm.cloudfunctions.net/staging'
const headers = {'Accept': 'application/json'};
const bleads = []
let exLeads = []
let prints = []
export default {
  data(){
    return {
      nwarehouses:[],
      nproducts:[],
      productscard:false,
      warehousecard:false,
      reservationcard:false,
      settingscard:false,
			loading: false,
      products:[],
      syncing:false,
      selectedProduct:null,
      countries:[],
      warehouses:[],
      nwarehouse:{},
      selectedWarehouse:null,
      dialog: false,
      nName:null,
      nSKU:null,
      dialogAdd: false,
      dialogImport: false,
      pastedData:null,
      delimiter:null,
      importTotal:0,
      importDone:0,
      leads:[],
      changeLeads:[],
      loadedProducts:[],
      bleads:[],
      customLog:null,
      loading:false,
      customLogLead:null,
      limit:2000,
      settings:[],
      selectedSetting:null,
      countriesFullLoaded:[],
      taxrates:[],
      proccessSettings:[
        {s:'order_status', v:'Confirmed', p:5}, 
        {s:'shipping_status', v:'pending', p:1},
        {s:'shipping_status', v:'Reschedule', p:2},
        {s:'shipping_status', v:'Out of stock', p:3},
        {s:'shipping_status', v:'unpacked', p:4},
      ],
      loadedDbCountries:['Jordan', 'JO', 'Jo', 'KSA', 'Saudi Arabia', 'Iraq', 'IRQ', 'IQ',  'UAE', 'United Arab Emarites', 'Oman', 'oman', 'OMAN', 'Kuwait', 'KW', 'Palestine', 'PS', 'PLE', 'Gaza', 'غزة', 'Egypt', 'EG', 'Qatar', 'QA', 'LB', 'Lebanon', 'YE', 'Yemen'],
      backupsku:null,
      whsource:null,
      whtarget:null,
      importingAlt:null,
      src:null,
      testing:false,
    }
  },
  methods: {
    async importAlternatives() {
      this.loading = true
      let s = this.whsource
      let t = this.whtarget
      let p = await store.collection('productsLive').get()
      .then(x=>x.docs.map(y=>{
        let w = y.data().warehouses
        if (w) {
          w.forEach(x=>{
            if(!x.alternatives) {
              x.alternatives = []
            }
          })
        }
        return {
          ...y.data(),
          alternatives: y.data().alternatives ? y.data().alternatives:[],
          warehouses: w ? w : [],
          key:y.id
        }
      }));
      (async x=>{
        for (let i = 0; i < p.length; i++) {
          const product = p[i];
          this.importingAlt = `scaning ${product.sku}`
          let pwh = product.warehouses.filter(x=>x.warehouse == this.whsource.name)
          if(pwh && pwh.length) {
            let alts = pwh[0].alternatives
            let twhi = product.warehouses.findIndex(x=>x.warehouse == this.whtarget.name)
            console.log(alts)
            console.log(twhi)
            if(product.warehouses[twhi] && alts.length) {
              product.warehouses[twhi].alternatives = alts
              console.log('success update', product)
              this.importingAlt = `updating ${product.sku}`
              await store.collection('productsLive').doc(product.key).update(product)
            }
          }
        }
        this.loading = false
        this.importingAlt = null
      })()
    },
    async backuplive() {
      let p = await store.collection(`productsLive`).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      console.log(p);
      (async x=>{
        for (let i = 0; i < p.length; i++) {
          const product = p[i];
          console.log(product);
          await store.collection(`productsLiveBackup`).doc(product.key).set(product)
          this.backupsku = product.sku
        }
        this.backupsku = null
      })()
    },
    addWareHouseToSettings(){
      let a = {...this.selectedSetting}
      if(!this.selectedSetting.warehouses) this.selectedSetting.warehouses = {}
      this.selectedSetting.warehouses[randomString(6, 'Aa')] = {
        name:null,
        priority:null,
      }
      console.log(this.selectedSetting)
      this.selectedSetting = null
      this.selectedSetting = a
    },
    async updateSettings(){
      console.log(this.selectedSetting)
      await db.ref(`settings/reservation/${this.selectedSetting.key}`).update(this.selectedSetting)
      this.selectedSetting = null
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			return result
    },
    async getSettings(){
      let b = await db.ref(`settings/reservation`).once('value').then(x=>x.val());
      let k = Object.keys(b)
      this.settings = Object.values(b).map((x, i)=>{return{...x, key:k[i], text:`Settings for ${x.country[0]}`}})
      console.log('------------------------------------');
      console.log(this.settings);
      console.log('------------------------------------');
    },
    async importWarehouses(){
      let b = this.getArray()
      this.importTotal = b.length
      this.importDone = 0
      console.log('------------------------------------');
      console.log(b);
      console.log('------------------------------------');
      (async x=>{
        for (let i = 0; i < b.length; i++) {
          const item = b[i];
          let p = await store.collection(`productsLive`).where('sku', '==', item.sku.trim()).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}})[0])
          if(p){
            let w = this.warehouses.map(x=>x.name)
            for (let k = 0; k < w.length; k++) {
              const wa = w[k];
              if(item[wa]){
                if(!p.warehouses) p.warehouses = []
                if(p.warehouses && !p.warehouses.map(x=>x.warehouse).includes(wa)) {
                  p.warehouses.push({
                    quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                    warehouse:wa
                  })
                } else if(p.warehouses && p.warehouses.map(x=>x.warehouse).includes(wa)){
                  let ind = p.warehouses.map(x=>x.warehouse).indexOf(wa)
                  p.warehouses[ind].quantity = item[wa] && item[wa] != '' ? item[wa] : '0'
                  p.warehouses[ind].warehouse = wa
                }
              }
            }
            console.log(p)
            await store.collection('productsLive').doc(p.key).update(p)
          } else {
            let product = {
              item_name:item.item_name,
              sku:item.sku,
            }
            let w = this.warehouses.map(x=>x.name)
            for (let k = 0; k < w.length; k++) {
              const wa = w[k];
              if(!product.warehouses) product.warehouses = []
              if(product.warehouses && !product.warehouses.map(x=>x.warehouse).includes(wa)) {
                product.warehouses.push({
                  quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                  warehouse:wa
                })
              }
            }
            // await store.collection('productsLive').doc(product.key).add(product)
          }
          this.importDone = i
        }
      })()
    },
    async getProducts(k){
      this.loading = true
      this.products = await store.collection('productsLive').get()
      .then(x=>x.docs.map(y=>{
        let w = y.data().warehouses
        if (w) {
          w.forEach(x=>{
            if(!x.alternatives) {
              x.alternatives = []
            }
          })
        }
        return {
          ...y.data(),
          alternatives: y.data().alternatives ? y.data().alternatives:[],
          warehouses: w ? w : [],
          key:y.id
        }
      }))
      if(k){
        this.selectedProduct = this.products.filter(x=>x.key == k)[0]
      }
      this.loading = false
    },
    async warehouseAdd(){
      await store.collection('warehouses').add(this.nwarehouse)
      this.dialog = false
      this.getWarehouses()
    },
    async getWarehouses(){
      this.loading = true
      this.countries = await db.ref(`settings/dbfilters/countries`).once('value').then(x=>x.val().map(x=>x.toUpperCase()))
      const whs = await store.collection('warehouses').get().then(x=>x.docs.map(y => { return { ...y.data(), key: y.id, text: `${y.data().name} ${y.data().country}` } }))
      console.log(whs)
      console.table(whs)
      this.warehouses = whs.filter(x => !x.lock)
      console.log(this.warehouses)
      console.table(this.warehouses)
      this.loading = false
    },
    removeWearhouse(k){
			this.selectedProduct.warehouses.splice(k, 1)
		},
		addWarehouse(key){
			console.log('a')
			this.selectedProduct.warehouses.push({
				warehouse:'',
        quantity:0,
        alternatives:[]
			})
    },
    addAlternative(index){
      
      this.selectedProduct.warehouses[index].alternatives.push({
        sku:'',
        priority:this.selectedProduct.warehouses[index].alternatives.length+1
			})
    },
    async updateProduct() {
      console.log(this.selectedProduct)
      await store.collection('productsLive').doc(this.selectedProduct.key).update(this.selectedProduct)
      this.getProducts(this.selectedProduct.key)
      this.loadWarehouseProducts()
    },
    loadWarehouseProducts(){
      if(this.selectedWarehouse) {
        let a  = this.products.filter(x=>x.warehouses && x.warehouses.map(x=>x.warehouse).includes(this.selectedWarehouse.name))
        this.selectedWarehouse.products = a
        console.log(a)
			  this.$emit('snackbarNotification', `${this.selectedWarehouse.name} is loaded`, 'success')
      }
    },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)

      return array.map(it => {
        return Object.values(it).toString()
      }).join('\n')
    },
    exportWarehouseh(){
      let a = this.convertToCSV(this.selectedWarehouse.products.map(x=>{
        return {
          item_name:x.item_name,
          sku:x.sku,
          quantity:x.warehouses.filter(x=>x.warehouse==this.selectedWarehouse.name)[0].quantity
        }
      }))
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri = encodeURI(csvContent + a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${this.selectedWarehouse.name}_report.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async changeReserve(lead, event) {
      let ba = this.bleads.filter(x=>x.key == lead.key)[0]
      let fn = this.changeLeads.findIndex(x=>x.key == ba.key)
      console.log(ba)
      console.log(lead)
      console.log(event)
      if(lead.reserve.products) {
        lead.reserve.products.forEach(item=>{
          console.log('before', this.loadedProducts.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == ba.warehouse)[0].quantity)
          this.loadedProducts.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == ba.warehouse)[0].quantity = parseInt(this.loadedProducts.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == ba.warehouse)[0].quantity) + parseInt(item.quantity)
          console.log('after', this.loadedProducts.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == ba.warehouse)[0].quantity)
        })
        lead.reserve = {products:[], warehouse:``}
      } else {
      }
      let a = []
      a.push(lead)
      console.log()
      let b = await db.ref(`settings/reservation`).once('value').then(x=>x.val());
      let settings = Object.values(b);
      let products = this.loadedProducts
      console.log(products);
      let backproducts = [...products];
      (async x=>{
        let applyLeads = []
        for (let i = 0; i < a.length; i++) {
          const lead = a[i];
          let filter = settings.filter(x=> x.country.includes(lead.country))
          if(filter[0]) {
            let s = filter[0]
            console.log(s)
            let o = lead.order
            console.log('order', o)
            let ic = o.length
            let fc = 0
            let xw = 0
            let wdone = true
            console.log(s.warehouses)
            console.log(lead.reserve)
            console.log(event.name)
            let w = Object.values(s.warehouses).filter(x=> x.name == event.name)[0]
            console.log(w)
            if(w){
              lead.reserve.warehouse = w.name
              console.log(lead.reserve.warehouse)
              console.log(`----------------W => ${xw + 1}--------------------`);
              function checkItem(item, sku){
                let p = products.filter(x=>x.sku == sku.trim())
                let pr = p[0]
                console.log(pr)
                let wr = pr && pr.warehouses ? pr.warehouses.filter(x=>x.warehouse == w.name)[0] : null
                console.log(wr)
                let wq = wr ? parseInt(wr.quantity) : 0
                console.log(wq)
                let oq = parseInt(item.quantity)
                console.log(oq)
                if(oq < wq){
                  return {product:pr, found:true, w:w.name, quantity:parseInt(item.quantity)}
                } else {
                  return {found:false}
                }
              }
              for (let i = 0; i < lead.order.length; i++) {
                const item = lead.order[i];
                let a = checkItem(item, item.sku)
                if(a.found){
                  if(!lead.reserve.products) lead.reserve.products = []
                  lead.reserve.products.push({
                    sku:a.product.sku,
                    w:a.w,
                    quantity:a.quantity
                  })
                  console.log('a', a)
                  console.log('a', products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses)

                  products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity = parseInt(products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity) - parseInt(item.quantity)

                  fc++
                } else {
                  let done = false;
                  let x = 0
                  let p = products.filter(x=>x.sku == item.sku.trim())
                  let pr = p[0] ? p[0].warehouses.filter(x=>x.warehouse == lead.reserve.warehouse)[0] : {}
                  do {
                    if(pr && pr.alternatives && pr.alternatives.length) {
                      let alt = pr.alternatives.sort((a, b) => parseInt(b.priority) - parseInt(a.priority))[x]
                      console.log('alt', alt)
                      if(alt){
                        let a = checkItem(item, alt.sku)
                        console.log('recheck', a)
                        if(a.found){
                          done = true
                          if(!lead.reserve.products) lead.reserve.products = []
                          lead.reserve.products.push({
                            sku:a.product.sku,
                            alternative:true,
                            for: item.sku,
                            w:a.w,
                            quantity:a.quantity
                          })
                          products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity = parseInt(products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity) - parseInt(a.quantity)
                          fc++
                        } else {
                          x++
                        }
                      } else {
                        done = true
                      }
                    } else {
                      done = true
                    }
                  } while (!done);
                }
              }
              if(ic==fc){
                console.log('we have all')
                wdone = false
              } else {
                fc=0
                if(lead.reserve.products){
                  this.$emit('snackbarNotification', `Cant reserve from ${event.name}`, 'error')
                  console.log(lead.reserve.products)
                  lead.reserve.products.forEach(item=>{
                    products.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == item.w)[0].quantity = parseInt(products.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == item.w)[0].quantity) + parseInt(item.quantity)
                  })
                  lead.reserve.products = []
                  lead.reserve = {}
                }
                lead.reserve = {}
              }
            } else {
              wdone = false
              lead.reserve.warehouse = null
              lead.reserve = {}
            }
          }
          console.log('lead', lead)
          applyLeads.push(lead)
        }
        console.log('-----------------applyLeads-------------------');
        console.log(applyLeads);
        applyLeads.forEach(x=>{
          if(!x.reserve) x.reserve = {}
        })
        console.log('-----------------changed lead-------------------', applyLeads);

        let fn = this.leads.findIndex(x=>x.key == lead.key)
        this.leads.splice(fn, 1, lead)
        this.bleads = []
        this.leads.filter(x=>x.reserve).forEach(x=>{
          this.bleads.push({key:x.key, warehouse:x.reserve.warehouse, products:x.reserve.products})
        })
        console.log('bleads', this.bleads)
        let nwarehouses = {}
        let nproducts = {}
        this.leads.filter(x=>x.reserve).forEach(lead=>{
          if(!nwarehouses[lead.reserve.warehouse]) nwarehouses[lead.reserve.warehouse] = {}
          if(!nwarehouses[lead.reserve.warehouse].count) nwarehouses[lead.reserve.warehouse].count = 0
          if(!nwarehouses[lead.reserve.warehouse].name) nwarehouses[lead.reserve.warehouse].name = lead.reserve.warehouse
          nwarehouses[lead.reserve.warehouse].count += 1
          if(lead.reserve.products)
          lead.reserve.products.forEach(item=>{
            if(!nproducts[item.sku]) nproducts[item.sku] = {}
            if(!nproducts[item.sku].sku) nproducts[item.sku].sku = item.sku
            if(!nproducts[item.sku].count) nproducts[item.sku].count = 0
            nproducts[item.sku].count += 1
            if(nwarehouses[lead.reserve.warehouse] && item.w == lead.reserve.warehouse) {
              if(!nwarehouses[lead.reserve.warehouse].products) nwarehouses[lead.reserve.warehouse].products = []
              if(!nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).includes(item.sku)) {
                nwarehouses[lead.reserve.warehouse].products.push({
                  sku:item.sku,
                  count:0
                })
                let n = nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).findIndex(x=> x == item.sku)
                nwarehouses[lead.reserve.warehouse].products[n].count += 1
              } else {
                let n = nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).findIndex(x=> x == item.sku)
                nwarehouses[lead.reserve.warehouse].products[n].count += 1
              }
            }
          })
        })
        this.nwarehouses = nwarehouses
        this.nproducts = nproducts
        let resProduct = products.filter(x=> Object.values(nproducts).map(y=>y.sku).includes(x.sku))
        console.log(backproducts.filter(x=> Object.values(nproducts).map(y=>y.sku).includes(x.sku)));
        console.log(resProduct);
        console.log(this.nwarehouses);
        console.log(this.nproducts);
        console.log(this.nwarehouses)
        console.log(applyLeads.map(x=>x.reserve));
        console.table(applyLeads.map(x=>x.reserve).filter(x=>x))
        console.log('------------------applyLeads------------------');
      })()
    },
    replaceCity(o){
      let filtered_cc = countriesJSON.filter(x=>x.cities)
      let all = []
      filtered_cc.forEach(x=>all.push(...x.cities.map(y=>{return {...y, ar:y.name }})))
      let c = all.filter(x=>x.ar == o)
      if(c.length && c[0]){
        return c[0].en
      } else {
        return o
      }
    },
    arabic(string){
      var arabic = /[\u0600-\u06FF]/;
      var pattern = /[\u0600-\u06FF\u0750-\u077F]/;
      let result = pattern.test(string);
      return arabic.test(string) && result
    },
    async getLeadsToProccess(){
      return new Promise(async (resolve, reject) => {
        // let timestampf = new Date().getTime()
        // let timestampt = new Date().getTime() - 3*24*60*60*1000
        let ds = this.proccessSettings
        let g = ds.sort((a, b) => a.p - b.p)
        console.log(g)
        let b = await db.ref(`settings/reservation`).once('value').then(x=>x.val());
        let settings = Object.values(b);
        let a = [];
        (async x=>{
          for (let i = 0; i < g.length; i++) {
            const dbs = g[i];
            this.customLog = `get ${dbs.s}: ${dbs.v}`
            // await sleep(100)
            console.log(dbs)
            let d = await store.collection('leads')
            // .where("timestamp", ">=", timestampf)
            // .where("timestamp", "<=", timestampt)
            .where(dbs.s, '==', dbs.v)
            .limit(parseInt(this.limit)).get().then(x=>x.docs.map((y, i)=>{
              return {...y.data(), key:y.id}
            }))
            console.log(dbs.s, '==', dbs.v, d)
            let n = d.filter(x=>x.order).sort((a, b) => b.order.length - a.order.length)
            .filter( (x)=>{
              let dd = x.dispatch_date ? new Date(x.dispatch_date).getTime() : null
              let today = new Date().getTime() + 3 * 60 * 60 * 10000
              if(!dd || dd < today){
                return x
              } else {
                console.log('removed order phone', x.phone_number_1)
                console.log('removed order key', x.key)
                console.log('dd', dd)
                console.log('today', today)
              }
            })
            .filter(x=>!x.reserved)
            n.forEach(x=>{
              x.en_city = this.replaceCity(x.city)
            })
            let nn = []
            for (let k = 0; k < n.length; k++) {
              const x = n[k];
              let o = await store.collection('leads')
                .where('phone_number_1', '==', x.phone_number_1)
                .get()
                .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
              this.customLog = `${x.key}`
              if(!x.ninja && o && o.length > 1) {
                let of = o.filter(y=>y.key !=x.key)
                let os = o.map(x=> x.shipping_status)
                this.customLog = `Old Statuses > ${os.filter(x=>x).join(', ')}`
                let osf = os.filter(x=>x).filter(x=>x && x.toLowerCase().includes('return'))
                if(osf.length > 1){
                  console.log(osf)
                  this.customLog = `Has 2 Returned`
                  if(x.paid){
                    this.customLog = `Take out`
                    nn.push(x)
                  } else {
                    x.order_status='Cancel reject previous order',
                    x.shipping_status='Cancel'
                    let status = 'Cancel reject previous order'.split(' ').join('_').toLowerCase()
                    if(!this.testing) {
                      let bb = await db.ref('uKeys').push()
                      if(!x.update_timeline) x.update_timeline = {}
                      x.update_timeline[bb.key] = {
                        status:status,
                        agent:this.$props.userName,
                        date:getCDate()
                      }
                      if(!x.status_timeline){
                        x.status_timeline = {}
                      }
                      if(!x.status_timeline[status]) {
                        x.status_timeline[status] = {}
                      }
                      x.status_timeline[status]['date'] = getCDate()
                      x.status_timeline[status]['agent'] = this.$props.userName
                      try {
                        await store.collection('leads').doc(x.key).update(x)
                      } catch (error) {
                        console.log(x.key)
                        console.log(x.phone_number_1)
                        console.log(error)
                      }
                      await db.ref('uKeys').update({
                        [bb.key]:null
                      })
                      try {
                        await axios.post(productApiUrl('leads'), x, {headers}).then(x=>x.data)
                      } catch (error) {
                        console.log('lead sync reservation error', error)
                      }
                      if(x.ninja) {
                        let pu = await axios.post(crmApiUrl(`crmleads/${x.id}`), x, {headers}).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
                      }
                    }
                    console.log('removed order phone', x.phone_number_1)
                    console.log('removed order key', x.key)
                  }
                } else {
                  nn.push(x)
                }
              } else {
                nn.push(x)
              }
              
            }
            let mn = [...nn.filter(x=>x.paid), ...nn.filter(x=>!x.paid)]
            a = [...a, ...mn.filter(x=>!a.map(y=>y.key).includes(x.key))]
          }
          this.customLog = `got leads`
          // await sleep(100)
          console.log('all lead', a)
          console.log('ninja->>>>>>>>>>>>>', a.filter(x=>x.ninja))
          let fl = a.filter(x=> x.name && x.address && x.address.length >= 30);
          let flo = a.filter(x=> !x.name || !x.address || x.address.length < 30);
          let fltoprocess = [...fl];
          let flNotprocess = [...flo];
          for (let i = 0; i < fltoprocess.length; i++) {
            const lead = fltoprocess[i];
            let filter = settings.filter(x=> x.country.includes(lead.city) || x.country.includes(lead.district) || x.country.includes(lead.country) )
            if(filter && filter.length) {
              let set = filter[0];
              if(set.english) {
                if(this.arabic(lead.name)) {
                  fltoprocess.splice(i, 1)
                  flNotprocess.push(lead)
                } else if(this.arabic(lead.address)) {
                  fltoprocess.splice(i, 1)
                  flNotprocess.push(lead)
                }
              }
            }
          }
          if(flNotprocess.length>0) {
            this.exportSimpleData(flNotprocess, 'failed_reserve')
          }
          resolve(fltoprocess);
        })()
      });
      
    },
    async reserve(){
      this.loading = true
      let a = await this.getLeadsToProccess()
      this.changeLeads = a
      console.log(a);
      let b = await db.ref(`settings/reservation`).once('value').then(x=>x.val());
      let settings = Object.values(b);
      this.customLog = `Got Settings`
      let products = await store.collection('productsLive').get()
      .then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          alternatives: y.data().alternatives ? y.data().alternatives:[],
          warehouses:y.data().warehouses? y.data().warehouses:[],
          key:y.id
        }
      }));
      this.customLog = `Got Products`
      this.loadedProducts = products
      console.log(products);
      let backproducts = [...products];
      (async x=>{
        let applyLeads = []
        let whcounter = {}
        for (let i = 0; i < a.length; i++) {
          const lead = a[i];
          console.log(`+++++++++++${lead.key}++++++++++++`)
          this.customLogLead = `${i+1}/${a.length+1}`
          this.customLog = `Proccessing Lead ${i+1} | ${lead.key}`
          let filter = settings.filter(x=> x.country.includes(lead.country) )
          if( settings.filter( x => x.country.includes(lead.city) || x.country.includes(lead.district) ).length ) {
            filter = settings.filter( x => x.country.includes(lead.city) || x.country.includes(lead.district) )
          }
          this.customLog = `Filtering settings`
          if(filter[0]) {
            let s = filter[0]
            // await sleep(10)
            console.log(s)
            let o = lead.order
            console.log(`order ${lead.key}`, o)
            lead.reserve = {}
            let ic = o.length
            let fc = 0
            let xw = 0
            let wdone = true
            do {
              this.customLog = `Checking warehouses`
              // await sleep(10)
              console.log(s.warehouses)
              let w = Object.values(s.warehouses).sort((a, b) => parseInt(a.priority) - parseInt(b.priority))[xw]
              console.log(w)
              
              if(w){
                if(!whcounter[w.name]) whcounter[w.name] = {}
                whcounter[w.name].limit = w.limit ? parseInt(w.limit) : 9999*9999*99999
                this.customLog = `Starting warehouse ${w.name}`
                lead.reserve.warehouse = w.name
                lead.reserve.key = lead.key
                console.log(`----------------W => ${xw + 1}--------------------`);
                function checkItem(item, sku){
                  let p = products.filter(x=>x.sku == sku.trim())
                  let pr = p[0]
                  console.log(pr)
                  let wr = pr && pr.warehouses ? pr.warehouses.filter(x=>x.warehouse == w.name)[0] : null
                  console.log(wr)
                  let wq = wr ? parseInt(wr.quantity) : 0
                  console.log(wq)
                  let oq = parseInt(item.quantity)
                  console.log(oq)
                  if(oq <= wq){
                    return {product:pr, found:true, w:w.name, quantity:parseInt(item.quantity)}
                  } else {
                    return {found:false}
                  }
                }
                for (let i = 0; i < lead.order.length; i++) {
                  const item = lead.order[i];
                  console.log(`item for ${lead.key}`, item.sku)
                  let a = checkItem(item, item.sku)
                  if(a.found){
                    if(!lead.reserve.products) lead.reserve.products = []
                    lead.reserve.products.push({
                      sku:a.product.sku,
                      w:a.w,
                      quantity:a.quantity
                    })
                    console.log('a', a)
                    console.log('a', products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses)

                    products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity = parseInt(products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity) - parseInt(item.quantity)
                    fc++
                    console.log(`reserve for ${lead.key}`, lead.reserve.products)
                  } else {
                    let done = false;
                    let x = 0
                    let p = products.filter(x=>x.sku == item.sku.trim())
                    let pr = p[0] ? p[0].warehouses.filter(x=>x.warehouse == lead.reserve.warehouse)[0] : {}
                    do {
                      // await sleep(100)
                      let tele = ["TELEMARKETING", "Telemarketing"]
                      if(!tele.includes(lead.ourder_source) && !lead.no_alternative && pr && pr.alternatives && pr.alternatives.length) {
                        let alt = pr.alternatives.sort((a, b) => parseInt(b.priority) - parseInt(a.priority))[x]
                        console.log('alt', alt)
                        if(alt){
                          let a = checkItem(item, alt.sku)
                          console.log('recheck', a)
                          if(a.found){
                            done = true
                            if(!lead.reserve.products) lead.reserve.products = []
                            lead.reserve.products.push({
                              sku:a.product.sku,
                              alternative:true,
                              for:item.sku,
                              w:a.w,
                              quantity:a.quantity
                            })
                            products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity = parseInt(products.filter(x=>x.sku == a.product.sku.trim())[0].warehouses.filter(x=>x.warehouse == a.w)[0].quantity) - parseInt(a.quantity)
                            fc++
                          } else {
                            if(!lead.out) lead.out = {}
                            if(!lead.out[w.name]) lead.out[w.name] = [];
                            lead.out[w.name].push({sku:item.sku})
                            x++
                          }
                        } else {
                          if(!lead.out) lead.out = {}
                          if(!lead.out[w.name]) lead.out[w.name] = [];
                          lead.out[w.name].push({sku:item.sku})
                          done = true
                        }
                      } else {
                        if(!lead.out) lead.out = {}
                        if(!lead.out[w.name]) lead.out[w.name] = [];
                        lead.out[w.name].push({sku:item.sku})
                        done = true
                      }
                    } while (!done);
                  }
                }
                if(ic==fc || (lead.upsell && lead.upsells && ic-lead.upsells == fc)){
                  console.log('we have all')
                  this.customLog = `we have all`
                  wdone = false
                  if(!whcounter[w.name].counter) whcounter[w.name].counter = 0
                  whcounter[w.name].counter += 1
                  if(whcounter[w.name].counter >= whcounter[w.name].limit) {
                    let wsv = Object.values(s.warehouses)
                    let wsk = Object.keys(s.warehouses)
                    let wsfn = wsv.findIndex(x=>x.name == w.name)
                    delete s.warehouses[wsk[wsfn]]
                    console.log('---------------Deleted Warehouse----');
                    console.log(s.warehouses);
                    console.log('------------------------------------');
                  }
                  lead.out = {}
                  if(!this.testing) {
                    let lock = await store.collection('leads').doc(lead.key).update({locked:true})
                  }
                } else {
                  fc=0
                  if(lead.reserve.products){
                    console.log(lead.reserve.products)
                    lead.reserve.products.forEach(item=>{
                      products.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == item.w)[0].quantity = parseInt(products.filter(x=>x.sku == item.sku.trim())[0].warehouses.filter(x=>x.warehouse == item.w)[0].quantity) + parseInt(item.quantity)
                    })
                    lead.reserve.products = []
                  }
                  xw++
                  
                  if(filter[0].upsell && filter[0].upsell.length && xw >= Object.values(s.warehouses).length && !lead.upsell && !lead.paid && !lead.manual_total ) {
                    console.log('----------Upsell------------');
                    console.log(xw);
                    console.log(Object.values(s.warehouses).length);
                    console.log(filter[0].upsell);
                    let ups = filter[0].upsell
                    let cup = lead.order.map(x=>x.sku)
                    let checkUP = false
                    lead.upsells = 0
                    lead.upsell_skus = []
                    for (let u = 0; u < ups.length; u++) {
                      const uitem = ups[u];
                      if(cup.includes(uitem) && cup.length>1){
                        checkUP = true
                        let fup = lead.order.findIndex(x=> x.sku == uitem)
                        lead.order.splice(fup, 1)
                        lead.upsell = true
                        lead.reserve.upsell = true
                        lead.upsells +=1
                        lead.upsell_skus.push(uitem)
                        console.log("after up remove", lead.order)
                      }
                    }
                    if(checkUP){
                      console.log('------------------------------------');
                      console.log('lead before new total!!!!!!!!!!!!!!!!!', lead.total)
                      let currRate = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
                      if(!currRate) return `0`
                      let totalBase = 0 
                      if(lead.order && Array.isArray(lead.order))
                        lead.order.forEach(order=>{
                          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
                        })
                      let total = totalBase * parseFloat(currRate.usd) 
                      if (lead.voucher) {
                        total = total - (parseFloat(lead.voucher.amount) * parseFloat(currRate.usd))
                      }
                      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
                      lead.total = totalBase.toFixed(2)
                      lead.total_converted = total.toFixed(2)
                      lead.currency = currRate.currencies ? currRate.currencies[0].code  : ''
                      lead.payment_cc = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0].alpha2Code
                      let ftaxRate = this.taxrates.filter(x=> x.country == lead.country)
                      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
                      lead.total_converted_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
                      lead.tax = (total * parseFloat(taxRate)).toFixed(2)

                      lead.reserve.total = lead.total
                      lead.reserve.total_converted = lead.total_converted
                      lead.reserve.total_converted_after_tax = lead.total_converted_after_tax
                      lead.reserve.tax = lead.tax
                      lead.reserve.upsell_skus = lead.upsell_skus
                      console.log('lead after new total!!!!!!!!!!!!!!!!!', lead.total)
                      console.log('------------------------------------');
                      xw = 0
                      fc = 0
                      console.log(xw)
                      wdone = true
                      
                    }
                    console.log(xw);
                    console.log('----------Upsell------------');
                  } else {
                  }
                  
                }
              } else {
                  wdone = false
                  lead.reserve.warehouse = null
                  lead.reserve = {}
              }
            } while (wdone);
          }
          console.log(`+++++++++++${lead.key}++++++++++++`)
          console.log('lead', lead)
          applyLeads.push(lead)
        }
        console.log('-----------------applyLeads-------------------');
        console.log(whcounter);
        console.log('-----------------applyLeads-------------------');
        console.log(applyLeads);
        applyLeads.forEach(x=>{
          if(!x.reserve) x.reserve = {}
        })
        this.leads = applyLeads
        this.bleads = []
        applyLeads.filter(x=>x.reserve).forEach(x=>{
          this.bleads.push({key:x.key, warehouse:x.reserve.warehouse, products:x.reserve.products})
        })
        console.log('bleads', this.bleads)
        let outwarehouse = applyLeads.map(x=>x.out)
        console.log(outwarehouse)
        let nwarehouses = {}
        let nproducts = {}
        applyLeads.filter(x=>x.reserve).forEach(lead=>{
          if(!nwarehouses[lead.reserve.warehouse]) nwarehouses[lead.reserve.warehouse] = {}
          if(!nwarehouses[lead.reserve.warehouse].count) nwarehouses[lead.reserve.warehouse].count = 0
          if(!nwarehouses[lead.reserve.warehouse].name) nwarehouses[lead.reserve.warehouse].name = lead.reserve.warehouse
          nwarehouses[lead.reserve.warehouse].count += 1
          if(!nwarehouses[lead.reserve.warehouse].export) nwarehouses[lead.reserve.warehouse].export = []
          if(lead.reserve.products)
          lead.reserve.products.forEach(item=>{
            if(!nproducts[item.sku]) nproducts[item.sku] = {}
            if(!nproducts[item.sku].sku) nproducts[item.sku].sku = item.sku
            if(!nproducts[item.sku].count) nproducts[item.sku].count = 0
            nproducts[item.sku].count += 1
            if(nwarehouses[lead.reserve.warehouse] && item.w == lead.reserve.warehouse) {
              if(!nwarehouses[lead.reserve.warehouse].products) nwarehouses[lead.reserve.warehouse].products = []
              if(!nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).includes(item.sku)) {
                nwarehouses[lead.reserve.warehouse].products.push({
                  sku:item.sku,
                  count:0
                })
                let n = nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).findIndex(x=> x == item.sku)
                nwarehouses[lead.reserve.warehouse].products[n].count += 1
              } else {
                let n = nwarehouses[lead.reserve.warehouse].products.map(x=>x.sku).findIndex(x=> x == item.sku)
                nwarehouses[lead.reserve.warehouse].products[n].count += 1
              }
            }
          })
        })

        this.nwarehouses = nwarehouses
        this.nproducts = nproducts
        let resProduct = products.filter(x=> Object.values(nproducts).map(y=>y.sku).includes(x.sku))
        console.log(backproducts.filter(x=> Object.values(nproducts).map(y=>y.sku).includes(x.sku)));
        console.log(resProduct);
        console.log(this.nwarehouses);
        console.log(this.nproducts);
        console.log(this.nwarehouses)
        console.log(applyLeads.map(x=>x.reserve));
        console.table(applyLeads.map(x=>x.reserve).filter(x=>x))
        console.log('------------------applyLeads------------------');
        this.loading = false
        this.reservationcard = true
      })()
    },
    async cancelAllReservation(){
      this.loading = true
      let m = this.leads;
      (async x=>{
        for (let i = 0; i < m.length; i++) {
          const lead = m[i];
          this.customLogLead = lead.key
          this.customLog = `Unlocking ${i} of ${m.length}`
          if(!this.testing) {
            let lock = await store.collection('leads').doc(lead.key).update({locked:false})
          }
        }
        this.loading = false
      })()
    },
    async cancelLeadReservation(lead, i){
      this.leads.splice(i, 1)
      let lock = await store.collection('leads').doc(lead.key).update({locked:false})
    },
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async exportData(data = this.leads, name, wexport){
      console.log(data)
      let exLeads = []
      let w = name ? name.replace(' ', '') : null
      let ws = {
        AramexUAE:{"key":"Order Number","":"Receiver ID","name":"Receiver Contact","address":"Receiver Address","city":"Receiver City","country":"Receiver Country","phone_number_1":"Receiver Phone","item_sku":"Material Code","item_quantity":"quantity","total_converted_after_tax":"COD Value SAR","item_name":"Description of Goods","wa_number":"watsappnumber","paid":"Paid", "note":"Note"},
        AramexKSA:{"key":"Order Number","":"1=YES 0=No","name":"Receiver Name","address":"Receiver Address","city":"City","phone_number_1":"Receiver Phone","phone_number_2":"Second PhoneNumber","item_sku":"SKU","item_quantity":"Quantity","total_converted_after_tax":"COD Value","currency":"Cash On Delivery (COD) Currency","item_name":"Description of Goods","paid":"Paid Online", "note":"Note"},
        SalasaKSA:{"key":"Order Number","":"Zip Code","item_name":"Item Descreption","phone_number_1":"Receiver Phone","name":"Receiver Name","address":"Receiver Address","city":"Main City","country":"Country","total_converted_after_tax":"Order Amount","dispatch_date":"Dispatched Date","item_sku":"SKU","item_quantity":"QTY","paid":"Paid", "note":"Note"},
        IRAQ:{"name":"Customer name","phone_number_1":"Customer Number","address":"Address","city":"City","total":"Price $","country":"Country","key":"Slip Number","phone_number_2":"2nd Phone Number","item_sku":"SKU","item_name":"Item Name","item_quantity":"Quantity", "note":"Note"},
        JordanWarehouse:{"":"shippingnote","key":"order id","item_name":"details","total_converted":"cod amount","name":"customer name","phone_number_1":"mobile","city":"city","address":"street", "note":"Note"}
      }
      let exdata = [];
      let b = await db.ref(`settings/reservation`).once('value').then(x=>x.val());
      let settings = Object.values(b);
      data.forEach(lead => {
        console.log(lead)
        let filter = settings.filter(x=> x.country.includes(lead.city) || x.country.includes(lead.district) || x.country.includes(lead.country) )
        let set = filter && filter.length ? filter[0] : {}
        let k = lead.status_timeline ? Object.keys(lead.status_timeline) : null
        let lastcdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i) => {
            return {
              ...x,
              key: k[i]
            }
          })
          .filter(x => x.key == 'dispatch')
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null
        let lastconfirmdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i) => {
            return {
              ...x,
              key: k[i]
            }
          })
          .filter(x => x.key == 'confirmed')
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null
        let Sdates = {}
        let kShip = lead.shipping_status_timeline ? Object.keys(lead.shipping_status_timeline) : null
        let lastSdate = lead.shipping_status_timeline ? Object.values(lead.shipping_status_timeline)
          .forEach((x, i) => {
            Sdates[kShip[i]] = x.date
          }) : []

        let lastagentdate = lead.status_timeline ? Object.values(lead.status_timeline).map((x, i)=>{return {...x, key:k[i]}})
          .filter(x => x.agent == lead.agent_name)
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          })[0] : null

        let ka = lead.update_timeline ? Object.keys(lead.update_timeline) : null
        let lastagentdatepre = lead.update_timeline ? Object.values(lead.update_timeline).map((x, i)=>{return {...x, key:ka[i]}})
          .filter(x => x.agent == lead.agent_name)
          .sort((a, b) => {
            new Date(b.date).getTime() - new Date(a.date).getTime()
          }) : null
        let lastagentdate2 = lastagentdatepre ? lastagentdatepre[0] : null;
        let out = lead.out ? lead.out : null
        let outK = out? Object.keys(out):[]
        if(outK.length) console.log(outK)
        let outV = out? Object.values(out):[]
        if(outV.length) console.log(outV)
        if (lead.order) {
          let order = lead.order
          for (let i = 0; i < order.length; i++) {
            const item = order[i];
            let alternative = lead.reserve && lead.reserve.products && lead.reserve.products.filter(x=>x.for==item.sku)[0] ? lead.reserve.products.filter(x=>x.for==item.sku)[0].sku:''
            let warehouse = lead.reserve && lead.reserve.warehouse? lead.reserve.warehouse : 'out'
            console.log(outK)
            let fnOutV = outV.findIndex(x=> x.map(y=>y.sku).includes(item.sku))
            console.log(fnOutV)
            let outSKU = fnOutV != -1 ? {sku_out:true, sku_warehouse_out:outK[fnOutV]} : {}
            console.log(outSKU)
            let ofsOutSKU = lead.reserve && lead.reserve.warehouse? {} : outSKU
            // delete lead.order
            let newLead = {
              ...lead,
              item_name: item.product,
              item_sku: item.sku,
              alternative,
              reserve_warehouse:warehouse,
              ...ofsOutSKU,
              item_unite_price: item.baseprice,
              item_quantity: item.quantity,
              item_discount: item.discount,
              last_dispatch_date: lastcdate ? lastcdate.date : null,
              last_dispatch_agent: lastcdate ? lastcdate.agent : null,
              last_confirm_date: lastconfirmdate ? lastconfirmdate.date : null,
              last_confirm_agent: lastconfirmdate ? lastconfirmdate.agent : null,
              last_agent_date: lastagentdate ? lastagentdate.date : null,
              last_agent_date2: lastagentdate2 ? lastagentdate2.date : null,
              ...Sdates
            }
            if(!set.delivery || !set.delivery.includes(item.sku)) {
              exLeads.push(newLead)
            }
            console.log(ws[w])
            if(ws[w]) {
              let nl = {}
              for (const key in ws[w]) {
                if (ws[w].hasOwnProperty(key)) {
                  const val = ws[w][key];
                  nl[val] = newLead[key] ? newLead[key] : ''
                }
              }
              console.log(nl)
              if(!set.delivery || !set.delivery.includes(item.sku)) {
                exdata.push(nl)
              }
            }
          }
        }
      });
      
      if(wexport && ws[w]){
        console.log(exdata)
        let a = json2csv.parse(exdata)
        console.log('CSV Ready')
        let csvContent = "data:text/csv;charset=utf-8," 
        var encodedUri =  csvContent + encodeURIComponent(a);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        let n = name ? name : 'reservation'
        link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
      } else {
        let a = json2csv.parse(exLeads)
        console.log('CSV Ready')
        let csvContent = "data:text/csv;charset=utf-8," 
        var encodedUri =  csvContent + encodeURIComponent(a);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        let n = name ? name : 'reservation'
        link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();
      }
    },
    getTotal(l, key){
      if (!l.order || l.order.length == 0) return `0`
      
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      l.total_converted = total.toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      this.genPaymentLink(l, l.key)
      return finalTotal
    },
    getTotalAfterTax(l, key){
      if (!l.order || l.order.length == 0) return `0`
      
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      l.total_invoice = (totalBase + totalBase * parseFloat(taxRate)).toFixed(2)
      l.total_converted_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.total_invoice_converted = ((totalBase + totalBase * parseFloat(taxRate)) * parseFloat(currRate.usd)).toFixed(2)

      if(l.manual_total){
        const cal_total = l.total_converted_after_tax
        let manual = parseFloat(l.manual_total)
        l.manual_discount = ((cal_total - manual) / cal_total) * 100
        l.total_invoice = (manual / parseFloat(currRate.usd)).toFixed(2)
        l.total_invoice_converted = manual
      } else {
        l.manual_discount = 0
      }
      l.tax = (total * parseFloat(taxRate)).toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      let finalTotalwithTax = {
        total:`${l.manual_total ? l.manual_total : l.total_converted_after_tax} ${currRate.currencies ? currRate.currencies[0].code  : ''}`,
        tax:(total * parseFloat(taxRate)).toFixed(2)
      }
      return finalTotalwithTax
    },
    async getTaxRates(){
      let a = await db.ref(`taxrates`).once('value').then(x=>x.val())
      this.taxrates = Object.values(a)
      console.log(this.taxrates)
    },
    async getCountries(){
      let a = countriesJSON
      let b = await db.ref('settings/dbfilters/countries').once('value').then(x=>x.val())
      this.loadedDbCountries = [...b, 'Gaza', 'غزة', 'Egypt', 'EG' ]
      this.countriesFullLoaded = Object.values(a)
      console.log(this.countriesFullLoaded)
    },
    async getNewDocNum() {
      await db.ref(`settings/barcode`)
        .transaction(function (current_value) {
          return (current_value || 0) + 1;
        });

      function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
      }
      let n = await db.ref(`settings/barcode`).once('value').then(x => x.val())
      let barcode = `B${pad(n, 8)}`
      return barcode
    },
    async parallelBackConfirm(data, length){
      try {
        let m = await axios.post(`${apiBaseStaging}/reservation`, data, headers).then(x=>x.data)
        console.log(m)
        exLeads.push(...m.exleads)
        m.exleads.forEach(lead=>{
          if(this.nwarehouses[lead.warehouse] && !this.nwarehouses[lead.warehouse].export) this.nwarehouses[lead.warehouse].export = []
          if(this.nwarehouses[lead.warehouse] && this.nwarehouses[lead.warehouse].export) this.nwarehouses[lead.warehouse].export.push(lead)
        })
        prints.push(m.WHI)
        if(length == exLeads.length) {
          // await sleep(9 * 60 * 1000)
          console.log(exLeads)
          this.exportData(exLeads, 'back_confirmed')
          await this.printer(prints)
          this.loading = false
        }
      } catch (error) {
        this.exportSimpleData(data, 'failed_back_confirm')
      }
      
    },
    async confirmReservation(backend = true){
      this.loading = true
      let res = this.leads.filter(x=>Object.keys(x.reserve).length).map(x=>{return {...x.reserve, testing:this.testing}})
      if(backend) {
        let a = res.sort((a, b) => a.warehouse.length - b.warehouse.length)
        let p_count = a.map(x=>x.products.length).reduce((partialSum, a) => partialSum + a, 0);
        let limit = 3
        let numNeeded = a.length / limit
        let loops = a.length % limit == 0 ? a.length / limit : parseInt(a.length / limit) + 1;
        try {
          (async x=>{
            for (let i = 0; i < loops + 1; i++) {
              console.log('------------------------------------');
              let data = a.slice(i*limit, i*limit+limit)
              console.log(data)
              this.parallelBackConfirm(data, a.length)
              console.log('------------------------------------');
              // await sleep(500)
              
            }
            this.loading = false
          })()
        } catch (error) {
          this.loading = false
        }
        
      } else {
        console.log(res);
        let b = await db.ref(`settings/reservation`).once('value').then(x => x.val());
	      let settings = Object.values(b);
        let products = await store.collection('productsLive').get()
        .then(x=>x.docs.map(y=>{
          let w = y.data().warehouses
          if (w) {
            w.forEach(x=>{
              if(!x.alternatives) {
                x.alternatives = []
              }
            })
          }
          return {
            ...y.data(),
            alternatives: y.data().alternatives ? y.data().alternatives:[],
            warehouses: w ? w : [],
            key:y.id
          }
        }));
        (async x=>{
          let exLeads = []
          let prints = []
		      let WHI = {}
          for (let i = 0; i < res.length; i++) {
            const lr = res[i];
            let lead = await store.collection(`leads`).doc(lr.key).get().then(x=>x.data())
            this.customLogLead = lead.key
            
            if(!lead.reserved) {
              this.customLog = `Reserving`
              let palt = lr.products.filter(x=>x.alternative)
              try {
                palt.forEach(item=>{
                  let aaa = lead.order.filter(x=>x.sku.trim() == item.for.trim())
                  this.customLog = `Replacing alternatives ${item.for.trim()}`
                  for (let ii = 0; ii < aaa.length; ii++) {
                    lead.order.filter(x=>x.sku.trim() == item.for.trim())[0].sku = item.sku
                    lead.order.filter(x=>x.sku.trim() == item.sku.trim())[ii].alternative = true
                    try {
                      lead.order.filter(x=>x.sku.trim() == item.sku.trim())[ii].product = 
                      products.filter(x=>x.sku == item.sku)[0].item_name
                    } catch (error) {
                      console.log(error)
                    }
                  }
                })
              } catch (error) {
                console.log(error)
              }
              if(lr.upsell_skus && lr.upsell_skus.length) {
                lead.order = lead.order.filter(x=> !lr.upsell_skus.includes(x.sku))
                lead.note =  lead.note? lead.note +`\nUpsells removed: ${lr.upsell_skus.join(',')}` : `Upsells removed: ${lr.upsell_skus.join(',')}`
                this.customLog = `Removing Upsells`
              }
              lead.order_status = 'Dispatch'
              lead.reserved = true
              lead.reserved_wh = true
              lead.locked = false


              if(lr.w){
                lead.warehouse = lr.w;
              }
              let status = 'Dispatch'.split(' ').join('_').toLowerCase()
              let bb = await db.ref('uKeys').push()
              if(!lead.update_timeline) lead.update_timeline = {}
              lead.update_timeline[bb.key] = {
                status:status,
                agent:this.$props.userName,
                date:getCDate()
              }
              if(!lead.status_timeline){
                lead.status_timeline = {}
              }
              if(!lead.status_timeline[status]) {
                lead.status_timeline[status] = {}
              }
              lead.status_timeline[status]['date'] = getCDate()
              lead.status_timeline[status]['agent'] = this.$props.userName


              await db.ref('uKeys').update({
                [bb.key]:null
              })
              if(lr.upsell){
                lead.total = lr.total
                lead.total_converted = lr.total_converted
                lead.total_converted_after_tax = lr.total_converted_after_tax
                lead.tax = lr.tax
                lead.upsell = true
              }
              console.log('warehouse b', this.nwarehouses[lr.warehouse])
              if(this.nwarehouses[lr.warehouse] && !this.nwarehouses[lr.warehouse].export) this.nwarehouses[lr.warehouse].export = []
              this.nwarehouses[lr.warehouse].export = []
              if(this.nwarehouses[lr.warehouse] && this.nwarehouses[lr.warehouse].export) this.nwarehouses[lr.warehouse].export.push(lead)
              console.log('warehouse a', this.nwarehouses[lr.warehouse])
              this.customLog = `Dispatching`
              lead.reserve = lr

              let filter = settings.filter(x => x.country.includes(lead.city) || x.country.includes(lead.district) || x.country.includes(lead.country))
              if (filter && filter.length && filter[0].genDocID && !lead.document_number) {
                lead.document_number = await this.getNewDocNum()
              }
              if (filter && filter.length && filter[0].genDocID && lead.reserve && lead.reserve.warehouse) {
                if (!WHI[lead.reserve.warehouse]) {
                  WHI[lead.reserve.warehouse] = []
                }
                WHI[lead.reserve.warehouse].push(lead.key)
              }

              console.log('lead city', lead.city)
              if (lead.city) {
                lead.en_city = this.replaceCity(lead.city)
                console.log('lead en_city', lead.en_city)
              }
              console.log('lead ready to update' , lead.key)
              if(!this.testing){
                await store.collection('leads').doc(lead.key).update(lead)

                // try {
                //   await axios.post('https://product.yervip.com/api/v1/leads', lead, {headers}).then(x=>x.data)
                // } catch (error) {
                //   console.log('lead sync reservation error', error)
                // }
                // if(lead.ninja) {
                //   let pu = await axios.post(`https://yervip.com/api/v1/crmleads/${lead.id}`, lead, {headers}).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
                // }
              }
              console.log(lr)
              console.table(lr.products.filter(x=>x.alternative))
              console.log(lead)
              console.log('upsell', lead.upsell)
              console.log(lead.order_status)
              console.log(lead.update_timeline[bb.key])
              console.log(lead.status_timeline[status])
              console.table(lead.order)
            }
            exLeads.push(lead)
          }
          console.log(exLeads)
          this.exportData(exLeads, 'front_confirmed')
          try {
            prints.push(WHI)
            await this.printer(prints)
          } catch (error) {
            console.log(error)
          }
          this.loading = false
        })()
      }
    },
    async printer() {
      (async x=>{
        console.log('printing')
        let WHM = {}
        for (let i = 0; i < prints.length; i++) {
          const WHI = prints[i];
          let keys = Object.keys(WHI)
          let b = Object.values(WHI)
          for (let k = 0; k < keys.length; k++) {
            const WHK = keys[k];
            if(!WHM[WHK]) { WHM[WHK] = []}
            WHM[WHK].push(...b[k])
          }
        }
        let WHMVs = Object.values(WHM)
        for (let i = 0; i < WHMVs.length; i++) {
          const WH = WHMVs[i];
          console.log('printing', WH)
          await this.printAllLeads(WH)
        }
      })()
    },
    async printAllLeads(keys) {
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await axios.post(`${apiBase}/invoice`, {orders:keys}, headers).then(x=>x.data)
        this.src = a
        var wnd = window.open("about:blank", "");
        wnd.document.write(this.src);
        wnd.document.close();
        wnd.print()
        this.loading = false
        res(a)
      })
    }
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  computed:{
  },
  watch:{
    loading(){
      if(!this.loading) {
        this.customLogLead = null
        this.customLog = null
      }
    }
  },
  async created(){
    this.getTaxRates()
    this.getCountries()
    this.getProducts()
    this.getWarehouses()
    this.getSettings()
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
